<template>
  <div class="card my-4 mx-4">
    <div
      class="card-header pb-0 d-flex justify-content-between align-content-center"
    >
      <h6>Models Category</h6>
      <RouterLink to="/models-category/add" class="btn btn-success">Create</RouterLink>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <!-- Data Table -->
      <data-table :dataList="paginatedCategories" :headerList="headerList">
        <template v-slot:action="slotProps">
          <router-link
            :to="{ path: `/models-category/edit/${slotProps.row.id}` }"
            class="btn btn-outline-dark px-2 py-1"
          >
            <i className="fa fa-pen"></i>
          </router-link>
          <button
            class="btn btn-outline-danger px-2 py-1 mx-1"
            @click="onDelete(slotProps.row.id)"
          >
            <i className="fa fa-trash"></i>
          </button>
        </template>
      </data-table>

      <!-- Pagination -->
      <div class="d-flex justify-content-center mt-3 gap-3 mr-3">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-text="First"
          prev-text="Prev"
          next-text="Next"
          last-text="Last"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "../../components/DataTable.vue";
import { RouterLink } from "vue-router";
import { mapGetters } from "vuex";

const headerList = [
  { name: "Sr.no", id: "id" },
  { name: "Name", id: "name" },
  { name: "Action", id: "action" },
];

export default {
  name: "ModelsCategory",
  components: {
    DataTable,
    RouterLink,
  },
  data() {
    return {
      headerList: headerList,
      currentPage: 1, // Current page
      perPage: 10, // Rows per page
    };
  },
  computed: {
    ...mapGetters("modelsCategory", ["modelsCategories", "isLoading"]),

    // Total rows in the data
    totalRows() {
      return this.modelsCategories.length;
    },

    // Paginated data for the current page
    paginatedCategories() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = this.currentPage * this.perPage;
      return this.modelsCategories.slice(start, end);
    },
  },
  mounted() {
    this.$store.dispatch("modelsCategory/fetchModelsCategories", null, {
      root: true,
    });
  },
  methods: {
    onDelete(id) {
      this.$swal({
        title: `Are you sure you want to delete Model Category?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch("modelsCategory/delete", id);
          this.$swal("Deleted!", `Model Category has been deleted.`, "success");
        }
      });
    },
  },
};
</script>
